import { type Filter, type FilterProps, mkFilter } from './filtersTypes';

export function transformFilterToRequestData(filter: Filter | FilterProps) {
  return {
    id: filter.id,
    isDeleted: filter.isDeleted,
    clientId: filter.clientId,
    type: filter.type,
    parentIds: filter.parentIds,
    filterItems: filter.filterItems,
  };
}

export function transformResponseToFilters(response?: { data?: { resources?: FilterProps[] } } | null) {
  return response?.data?.resources?.map((data) =>
    mkFilter({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      type: data.type,
      parentIds: data.parentIds,
      filterItems: data.filterItems,
    }),
  );
}

export const transformServerResourceToClientResource = (data: FilterProps) =>
  mkFilter({
    id: data.id,
    clientId: data.clientId,
    isDeleted: data.isDeleted,
    type: data.type,
    parentIds: data.parentIds,
    filterItems: data.filterItems,
  });
